module.exports = __webpack_public_path__ + "img/MSG_Banner.6eccfeff.png";